import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const Home = React.lazy(() => import("../screean/home/home"));
export function home() {
  return (
    <Route
      path="/home"
      element={
        <ProtectedRoute>
          <LazySuspense>
            <Home />
          </LazySuspense>
        </ProtectedRoute>
      }
      errorElement={<ErrorPage />}
    />
  );
}
